var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import ComponentWithProvider from "@frameworks/shared-library/components/customHooks/ComponentWithProvider";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
import somethingWentWrong from "@frameworks/shared-library/assets/images/markets/somethingWentWrong.svg";
import bookMarkDi from "@mainDi/features/bookmarks/servicelocator";
import TopFundsTableDesk, { EComponentFlow, } from "@frameworks//shared-library/components/TopPerformingFunds/TopFundsTableDesk";
import DeviceContext from "@frameworks//shared-library/components/customHooks/indentifyDevice";
import { defaultMutualFundsFilter, initialMFFilters, } from "@frameworks/shared-library/components/TopPerformingFunds/TopPerformingFundsTabs";
import _ from "underscore";
import TopFundsViewAllFunctionality from "@frameworks/shared-library/components/TopPerformingFunds/FundsViewAll/TopFundsViewAllFunctionality";
import noResultsFound from "@frameworks/shared-library/assets/images/markets/noResultsFound.svg";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { useNavigate } from "react-router-dom";
import di from "@mainDi/features/mutualFund/servicelocator";
import { EProductIds, ESubProductIds, } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import GenericToast from "@frameworks/shared-library/components/GenericToast";
var SavedProductMutualFund = function (props) {
    var device = DeviceContext();
    var navigate = useNavigate();
    var _a = __read(useState(0), 2), page = _a[0], setPage = _a[1]; //TODO: Need to check this if main filter state can be used in place of this
    var _b = __read(React.useState({
        isOpen: false,
        error: undefined,
        button: false,
        icon: undefined,
        msg: undefined,
        subMsg: undefined,
    }), 2), error = _b[0], setError = _b[1];
    var _c = __read(useState(false), 2), mutualFundsLoader = _c[0], setMutualFundsLoader = _c[1];
    var _d = __read(useState(), 2), mutualFundsSchemes = _d[0], setMutualFundsSchemes = _d[1];
    var _e = __read(useState(), 2), bookMarkData = _e[0], setBookMarkData = _e[1];
    var _f = __read(useState(false), 2), showToast = _f[0], setShowToast = _f[1];
    var _g = __read(useState({
        isError: false,
        msg: "",
    }), 2), toastDetails = _g[0], setToastDetails = _g[1];
    var _h = __read(React.useState(defaultMutualFundsFilter), 2), mutualFundDisplayFilters = _h[0], setMutualFundDisplayFilters = _h[1];
    var _j = __read(React.useState(JSON.parse(JSON.stringify(initialMFFilters))), 2), localMutualFundFilterSortValues = _j[0], setLocalMutualFundFilterSortValues = _j[1];
    var _k = __read(React.useState(JSON.parse(JSON.stringify(initialMFFilters))), 2), masterMutualFundFilterSortValues = _k[0], setMasterMutualFundFilterSortValues = _k[1];
    var _l = __read(React.useState(false), 2), isShowMainFilterSortPopup = _l[0], setIsShowMainFilterSortPopup = _l[1];
    var prevValuesRef = React.useRef(JSON.parse(JSON.stringify(initialMFFilters)));
    var _m = __read(React.useState(), 2), requestPayload = _m[0], setRequestPayload = _m[1];
    var _o = __read(React.useState({}), 2), selectedFiltersData = _o[0], setSelectedFiltersData = _o[1];
    var _p = __read(React.useState(), 2), configRequestPayload = _p[0], setConfigRequestPayload = _p[1];
    var _q = __read(useState(0), 2), totalPages = _q[0], setTotalPages = _q[1];
    var _r = __read(useState(0), 2), totalRecords = _r[0], setTotalRecords = _r[1];
    var isFirstRender = React.useRef(true);
    var getBookMark = function (req, isLoadMoreClicked) {
        if (isLoadMoreClicked === void 0) { isLoadMoreClicked = false; }
        var reqObj = __assign(__assign({}, req), { pageSize: props.showDataPerPage });
        setMutualFundsLoader(true);
        setError({
            isOpen: false,
            error: undefined,
            button: false,
            icon: undefined,
            msg: undefined,
            subMsg: undefined,
        });
        bookMarkDi.bookmarks
            .fetchBookmarks(reqObj)
            .then(function (data) {
            setMutualFundsSchemes(function (prev) {
                var _a;
                var mfschemeData = (_a = data === null || data === void 0 ? void 0 : data.mutualFundSummary) === null || _a === void 0 ? void 0 : _a.map(function (z) {
                    return __assign(__assign({}, z), { category: z.catName, subCategory: z.subCatName, aum: z.fundSize, isCtaAllowed: (z === null || z === void 0 ? void 0 : z.isCtaAllowed) === "Y", isOrderAllowed: (z === null || z === void 0 ? void 0 : z.isOrderAllowed) === "Y", schCd: z.schemeCode });
                });
                var bkData = mfschemeData === null || mfschemeData === void 0 ? void 0 : mfschemeData.map(function (x) { return x.schCd; });
                if (Number(req.pageNo) > 0 && prev && prev.length > 0) {
                    setBookMarkData(__spreadArray(__spreadArray([], __read(bookMarkData), false), __read(bkData), false));
                    return __spreadArray(__spreadArray([], __read(prev), false), __read(mfschemeData), false);
                }
                setBookMarkData(bkData);
                return mfschemeData;
            });
            if (data.totalRecord === 0) {
                setError({
                    isOpen: true,
                    error: undefined,
                    button: true,
                    icon: noResultsFound,
                    msg: "No saved products",
                    subMsg: "Explore top performing funds and save for future actions",
                    customButtonComponent: (React.createElement("div", { className: "d-flex align-items-center justify-content-center" },
                        React.createElement(EdButton, { btnTyp: "tomato-filled-rounded", value: "Explore Funds", onClick: handleNavigateToOfferings }))),
                });
            }
            setTotalPages(data.totalRecord / props.showDataPerPage);
            setTotalRecords(data.totalRecord);
        })
            .catch(function (error) {
            setError({
                isOpen: true,
                error: error,
                button: true,
                icon: somethingWentWrong,
                msg: "Something went wrong!!",
                subMsg: "Try refreshing page, or try again later",
            });
        })
            .finally(function () {
            setMutualFundsLoader(false);
        });
    };
    useEffect(function () {
        getBookmarkFilter(__assign(__assign({}, JSON.parse(JSON.stringify(initialMFFilters))), { categoryCode: [ESubProductIds.MutualFund], pageNo: 0 }));
    }, []);
    var deleteBookMark = function (schemeCode) { return __awaiter(void 0, void 0, void 0, function () {
        var isSuccessfullyDeleted;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setMutualFundsLoader(true);
                    isSuccessfullyDeleted = false;
                    return [4 /*yield*/, bookMarkDi.bookmarks
                            .deleteBookmarks({
                            schemeCode: schemeCode,
                        })
                            .then(function (z) {
                            // const localMutualFundSchemes:IMutualFundsSchemesListEntity[] =JSON.parse(JSON.stringify( mutualFundsSchemes))
                            var localSchemes = [];
                            setMutualFundsSchemes(function (book) {
                                var booklist = JSON.parse(JSON.stringify(book));
                                schemeCode.forEach(function (x) {
                                    var index = booklist.findIndex(function (z) { return z.schCd === x; });
                                    booklist.splice(index, 1);
                                });
                                setBookMarkData(booklist.map(function (x) { return x.schCd; }));
                                localSchemes = booklist;
                                setTotalRecords(totalRecords - 1);
                                if (!(totalRecords - 1)) {
                                    props.header(0, mutualFundsLoader);
                                    setError({
                                        isOpen: true,
                                        error: undefined,
                                        button: true,
                                        icon: noResultsFound,
                                        msg: "No saved products",
                                        subMsg: "Explore top performing funds and save for future actions",
                                        customButtonComponent: (React.createElement("div", { className: "d-flex align-items-center justify-content-center" },
                                            React.createElement(EdButton, { btnTyp: "tomato-filled-rounded", value: "Explore Funds", onClick: handleNavigateToOfferings }))),
                                    });
                                }
                                setTotalPages(booklist.length / props.showDataPerPage);
                                return booklist;
                            });
                            if (totalRecords - 1 > 0 && !localSchemes.length) {
                                getBookMark(__assign(__assign({}, masterMutualFundFilterSortValues), { pageSize: props.showDataPerPage }));
                            }
                            setShowToast(true);
                            setToastDetails({
                                isError: false,
                                msg: "Bookmark removed Successfully!",
                            });
                            isSuccessfullyDeleted = true;
                        })
                            .catch(function (error) {
                            setShowToast(true);
                            setToastDetails({
                                isError: true,
                                msg: "Failed to remove Bookmark!",
                            });
                            isSuccessfullyDeleted = false;
                        })
                            .finally(function () {
                            setMutualFundsLoader(false);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, isSuccessfullyDeleted];
            }
        });
    }); };
    var getBookmarkFilter = React.useMemo(function () {
        return function (filterValues) {
            if (filterValues === void 0) { filterValues = localMutualFundFilterSortValues; }
            if (_.isEqual(filterValues, prevValuesRef.current && !isFirstRender.current)) {
                return;
            }
            di.mutualFunds
                .getFilters(__assign({}, filterValues))
                .then(function (data) {
                if (!!data) {
                    setMutualFundDisplayFilters(data);
                    // Update prevValuesRef after successful API call
                    prevValuesRef.current = filterValues;
                }
            })
                .catch(function (err) {
                console.log(err);
            });
            if (isFirstRender.current) {
                isFirstRender.current = false;
            }
        };
    }, [masterMutualFundFilterSortValues, localMutualFundFilterSortValues]);
    var handleUpdateMasterSortFilterValuesState = function (data) {
        setMasterMutualFundFilterSortValues(data);
    };
    var handleApplyFilter = function (data) {
        var filterValues = data ? data : __assign({}, localMutualFundFilterSortValues);
        setPage(0);
        handleUpdateMasterSortFilterValuesState(filterValues);
        // getBookmarkFilter(filterValues);
        getBookMark(__assign(__assign({}, filterValues), { pageNo: 0 }));
        setIsShowMainFilterSortPopup(false);
    };
    var handleCancelApplyingFilter = function () {
        setIsShowMainFilterSortPopup(false);
        setLocalMutualFundFilterSortValues(__assign({}, masterMutualFundFilterSortValues));
    };
    var resetFilterSortValuesStatesToInitial = function () {
        setMasterMutualFundFilterSortValues(JSON.parse(JSON.stringify(initialMFFilters)));
        setLocalMutualFundFilterSortValues(JSON.parse(JSON.stringify(initialMFFilters)));
        setPage(0);
        setSelectedFiltersData({});
    };
    var handleClearAllFilters = function () {
        setPage(0);
        getBookMark(
        // { ...MutualFundsSchemesConfig[tab], pageNumber: 0 }
        JSON.parse(JSON.stringify(initialMFFilters)));
        // getBookmarkFilter(JSON.parse(JSON.stringify(initialMFFilters)));
        resetFilterSortValuesStatesToInitial();
    };
    var handleUpdateSelectedFiltersState = function (data) {
        setSelectedFiltersData(data);
    };
    var onFilterSelectionCallback = function (data, isDirectApi) {
        if (isDirectApi === void 0) { isDirectApi = false; }
        setLocalMutualFundFilterSortValues(data);
        if (isDirectApi) {
            handleApplyFilter(data);
        }
    };
    var handleClearSpecificFilter = function (filterKeyName) {
        var _a;
        var filterValues = __assign(__assign({}, masterMutualFundFilterSortValues), (_a = {}, _a[filterKeyName] = initialMFFilters[filterKeyName], _a));
        var localSelectedData = __assign({}, selectedFiltersData);
        delete localSelectedData[filterKeyName];
        onFilterSelectionCallback(filterValues);
        handleUpdateSelectedFiltersState(localSelectedData);
        handleApplyFilter(filterValues);
    };
    var handleNavigateToOfferings = function () {
        navigate("/dashboard/product-bouquet");
    };
    useEffect(function () {
        getBookMark(__assign(__assign({}, masterMutualFundFilterSortValues), { searchText: props.searchText, pageNo: 0, pageSize: props.showDataPerPage }));
        // getBookmarkFilter();
    }, [props.searchText]);
    return (React.createElement("div", { className: "d-flex flex-column gap-20" },
        React.createElement("div", { className: "primary-offerings-tabs-wrapper top-funds-tabs " },
            React.createElement(ComponentWithProvider, { component: React.createElement(React.Fragment, null,
                    props.viewAll && (React.createElement(TopFundsViewAllFunctionality, { mutualFundsSchemeList: mutualFundsSchemes, configRequestPayload: configRequestPayload, requestPayload: requestPayload, getMutualFundsSchems: getBookMark, filtersDisplayData: mutualFundDisplayFilters, mutualFundFilterSortValues: localMutualFundFilterSortValues, mutualFundFilterSortValuesApplied: masterMutualFundFilterSortValues, onFilterSelectionCallback: onFilterSelectionCallback, handleApplyFilterCallback: handleApplyFilter, handleCancelApplyingFiltersCallback: handleCancelApplyingFilter, handleClearAllFiltersCallback: handleClearAllFilters, setIsShowMainFilterSortPopup: setIsShowMainFilterSortPopup, isShowMainFilterSortPopup: isShowMainFilterSortPopup, selectedFiltersData: selectedFiltersData, handleUpdateSelectedFiltersState: handleUpdateSelectedFiltersState })),
                    !mutualFundsLoader && (React.createElement("div", { className: "pdl-40 pb-20" }, props.header &&
                        props.header(totalRecords, mutualFundsLoader))),
                    error.isOpen ? (React.createElement("div", { className: "custom-error-state" },
                        React.createElement(Errormsg, { image: error.icon, msg: error.msg, customComp: React.createElement("div", { className: "error-state-button-bar d-flex" },
                                React.createElement("p", { className: "DMSanN_14_400" }, error.subMsg),
                                error.button && (error === null || error === void 0 ? void 0 : error.customButtonComponent) ? (error.customButtonComponent) : (React.createElement("button", { className: "align-items-center DMSanN_13_500", onClick: function () {
                                        getBookMark({
                                            searchText: props.searchText,
                                            pageNo: 0,
                                            pageSize: props.showDataPerPage,
                                        });
                                    } }, "Try Again"))) }))) : (React.createElement(React.Fragment, null, device && device.isDesktop ? (React.createElement(React.Fragment, null,
                        React.createElement(TopFundsTableDesk, { mutualFundsSchemeList: mutualFundsSchemes, viewAll: props.viewAll, 
                            // paramsData={}
                            page: page, nextPage: function (page) {
                                setPage(page);
                                getBookMark(__assign(__assign({}, masterMutualFundFilterSortValues), { pageNo: page }), true);
                            }, loader: mutualFundsLoader, bookMarkData: bookMarkData, 
                            // savebookMark={savebookMark}
                            deleteBookMark: deleteBookMark, filterDataList: mutualFundDisplayFilters, handleApplyFilterCallback: handleApplyFilter, handleCancelApplyingFiltersCallback: handleCancelApplyingFilter, handleClearSpecificFilter: handleClearSpecificFilter, onFilterSelectionCallback: onFilterSelectionCallback, mutualFundFilterSortValues: localMutualFundFilterSortValues, totalPages: totalPages, dataLengthPerPage: props.showDataPerPage, handleUpdateSelectedFiltersState: handleUpdateSelectedFiltersState, selectedFiltersData: selectedFiltersData, saveButtonText: "Remove Bookmark", categoryCode: ESubProductIds.MutualFund, productCode: EProductIds.MANAGED_PORTFOLIO, componentFlow: EComponentFlow.SAVED_PRODUCT }),
                        !props.viewAll &&
                            !mutualFundsLoader &&
                            totalRecords > (props === null || props === void 0 ? void 0 : props.showDataPerPage) && (React.createElement("button", { className: "btn d-flex align-items-center txt-han-blue pdl-40 view-all-button", onClick: function () {
                                return props.viewAllClick && props.viewAllClick("mf");
                            } },
                            React.createElement("span", { className: "text-decoration-underline DMSanN_16_400" }, "View All"),
                            React.createElement("i", { className: "edel-icon-arrow-right-big viewAll-arrow" }))))) : (React.createElement(React.Fragment, null))))) })),
        React.createElement(GenericToast, { message: React.createElement("div", { className: "d-flex align-items-center gap-2" },
                toastDetails.isError ? (React.createElement("span", { className: "edel-icon-red-cross rounded-circle" })) : (React.createElement("span", { className: "edel-icon-tick bg-lime-green rounded-circle" })),
                React.createElement("span", null, toastDetails.msg)), showHeader: false, position: "bottom-center", showCloseButtonInBody: true, theme: "dark-slate-blue", show: showToast, setClose: function () { return setShowToast(false); }, autohide: true, parentClassName: "product-bouquet-toast" })));
};
export default SavedProductMutualFund;
